import { Link } from "@tanstack/react-router";
import { GraduationCap } from "lucide-react";
import type * as React from "react";
import {
  EntityCardContent,
  EntityCardsGrid,
  entityCardClass,
} from "@/components/shared/entity-cards";
import { LifecycleBadge } from "@/components/shared/lifecycle-badge";
import type { Skill } from "@/hooks/use-skills";
import { carryListSearch } from "@/lib/list-search";

interface SkillCardsProps {
  skills: Skill[];
  loading?: boolean;
  empty: React.ReactNode;
}

export function SkillCards({ skills, loading, empty }: SkillCardsProps) {
  return (
    <EntityCardsGrid loading={loading} isEmpty={skills.length === 0} empty={empty}>
      {skills.map((skill) => (
        <Link
          key={skill.id}
          to="/dashboard/skills/$skillId"
          params={{ skillId: skill.id }}
          search={carryListSearch()}
          aria-label={`Open ${skill.name}`}
          className={entityCardClass(true)}
        >
          <EntityCardContent
            icon={GraduationCap}
            title={skill.name}
            subtitle={
              skill.roles.length > 0 ? skill.roles.map((r) => r.name).join(", ") : "No roles"
            }
            trailing={<LifecycleBadge status={skill.status} />}
          />
        </Link>
      ))}
    </EntityCardsGrid>
  );
}
